(() => {
  const loader = document.currentScript;
  const sectionId = loader?.dataset.sectionId;

  if (!sectionId) return;

  const productSection = Array.from(
    document.querySelectorAll('.sl-enhanced-product[data-section-id]')
  ).find((section) => section.dataset.sectionId === sectionId);

  const badgeText = productSection?.dataset.assortionAddonBadge?.trim();

  if (!productSection || !badgeText) return;

  // Mehrere Badges pro Produkt: "Match::Badge|Match::Badge".
  // Ohne "::" gilt der ganze Text unveraendert fuer alle Addon-Boxen.
  // "titel:Match::Zeilentext" ersetzt den sichtbaren Titel der Zeile. Assortion fuehrt das Label
  // je Produkt nur einsprachig; die Uebersetzungen des Metafelds tragen damit den Text der
  // Seitensprache. Aeltere Fassungen dieses Skripts uebergehen die Regel, weil ihr Match nie im
  // Zeilentext steht.
  const TITLE_PREFIX = /^titel:/;
  const TITLE_ATTRIBUTE = 'data-tw-addon-title';
  const parsed = badgeText
    .split('|')
    .map((part) => {
      const idx = part.indexOf('::');
      return idx === -1
        ? { match: null, label: part.trim() }
        : { match: part.slice(0, idx).trim().toLowerCase(), label: part.slice(idx + 2).trim() };
    })
    .filter((rule) => rule.label);
  const rules = parsed.filter((rule) => !TITLE_PREFIX.test(rule.match || ''));
  const titleRules = parsed
    .filter((rule) => TITLE_PREFIX.test(rule.match || ''))
    .map((rule) => ({ match: rule.match.replace(TITLE_PREFIX, '').trim(), label: rule.label }))
    .filter((rule) => rule.match);

  const badgeFor = (group) => {
    const text = group.textContent.toLowerCase();
    const rule = rules.find((r) => !r.match || text.includes(r.match));
    return rule ? rule.label : null;
  };

  // Der App-Text bleibt im Dokument; override.css blendet ihn aus und zeigt das Attribut.
  const applyTitles = (group) => {
    group.querySelectorAll('.ast-addon-item').forEach((item) => {
      const title = item.querySelector('.ast-addon-item-title');
      if (!title) return;

      const text = item.textContent.toLowerCase();
      const rule = titleRules.find((r) => text.includes(r.match));
      if (!rule) {
        if (title.hasAttribute(TITLE_ATTRIBUTE)) title.removeAttribute(TITLE_ATTRIBUTE);
      } else if (title.getAttribute(TITLE_ATTRIBUTE) !== rule.label) {
        title.setAttribute(TITLE_ATTRIBUTE, rule.label);
      }
    });
  };

  const applyBadge = () => {
    productSection.querySelectorAll('.ast-addon-group').forEach((group) => {
      if (!group.querySelector('.ast-addon-item')) return;

      applyTitles(group);

      const label = badgeFor(group);
      if (!label) {
        group.classList.remove('tw-has-custom-badge');
        return;
      }

      group.classList.add('tw-has-custom-badge');
      group.dataset.assortionBadge = label;
    });
  };

  applyBadge();

  new MutationObserver(applyBadge).observe(productSection, {
    childList: true,
    subtree: true
  });
})();
